module.exports = __webpack_public_path__ + "static/vol5_03-03da4ae5d2d50aedf9f6e086aab0c382.gif";